import React from 'react';
import { Slider } from '@mui/material';
import DotPoint from '@src/assets/images/dot-pricing.png';

const styleMark = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: '#fff',
  border: '1.25px solid #007AFF',
  zIndex: 100,
};

const CreditsSlider = ({
  currentCredits,
  handleChangeCredits,
  maxNumberOptionCredit,
  minNumberOptionCredit,
  marks,
}) => (
  <Slider
    value={currentCredits}
    onChange={handleChangeCredits}
    step={null}
    marks={marks}
    min={0}
    max={maxNumberOptionCredit + minNumberOptionCredit}
    valueLabelDisplay="off"
    sx={{
      marginBottom: '14px',
      marginTop: '10px',
      '& .MuiSlider-track': {
        backgroundColor: 'gray',
        color: '#007AFF7A',
        height: '8px',
        border: 'none',
        zIndex: 99,
        opacity: currentCredits === maxNumberOptionCredit && 0,
      },
      '& .MuiSlider-rail': {
        backgroundColor:
          currentCredits === maxNumberOptionCredit ? '#007AFF7A' : '#007AFF14',
        height: '8px',
        opacity: currentCredits === maxNumberOptionCredit ? 1 : 0.5,
      },
      '& .MuiSlider-thumb': {
        width: 40,
        height: 40,
        color: 'transparent',
        zIndex: 200,
        borderRadius: '0%',
        marginLeft: '2px',
        backgroundImage: `url(${DotPoint})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxShadow: 'none!important',
        '&:hover': {
          boxShadow: '5px 10px transparent',
        },
        '&.Mui-active': {
          boxShadow: '5px 10px transparent',
        },
        '&:focus': {
          boxShadow: '5px 10px transparent',
        },
      },
      '& .MuiSlider-thumb:before': {
        boxShadow: '5px 10px transparent',
      },
      '& .MuiSlider-mark': {
        backgroundColor: 'transparent',
      },
      '& .MuiSlider-mark:nth-child(5)': styleMark,
      '& .MuiSlider-mark:nth-child(7)': styleMark,
      '& .MuiSlider-mark:nth-child(9)': styleMark,
      '& .MuiSlider-markLabel': {
        fontWeight: 400,
        fontSize: 12,
        letterSpacing: -0.4,
        textAlign: 'center',
        color: '#1C1C1E7A',
      },
      '& .MuiSlider-markLabelActive': {
        color: '#1976d2',
      },
    }}
  />
);

export default CreditsSlider;
